import { useEffect } from 'react';
import InnerLayout from '../components/InnerLayout';

export default function EnviosDevoluciones() {
  useEffect(() => { document.title = 'Envíos y Devoluciones — Sttora'; }, []);
  return (
    <InnerLayout titleFirst="Envíos y" titleAccent="Devoluciones" subtitle="Política de entrega, envío y proceso de devolución de productos Sttora." breadcrumb="Envíos y Devoluciones">
      <div className="legal-updated">Última actualización: Enero 2026</div>
      <div className="legal-content">
        <h2>Política de Envíos</h2>
        <p>Sttora ofrece opciones de envío a domicilio y retiro en centros de consolidación autorizados. Los tiempos y costos varían según la región, el tipo de producto y la modalidad seleccionada.</p>
        <ul>
          <li><strong>Envío estándar:</strong> 3–7 días hábiles según destino</li>
          <li><strong>Envío express:</strong> 24–48 horas en zonas de cobertura disponible</li>
          <li><strong>Retiro en punto Sttora:</strong> disponible en tiendas de cercanía y centros de consolidación</li>
        </ul>
        <h2>Zonas de Cobertura</h2>
        <p>La disponibilidad de envíos y tiempos de entrega dependen de la zona geográfica del comprador. Consulta la disponibilidad en tu región durante el proceso de compra.</p>
        <h2>Seguimiento de Pedidos</h2>
        <p>Una vez confirmado tu pedido, recibirás un número de seguimiento por correo electrónico para monitorear el estado de tu entrega en tiempo real.</p>
        <h2>Política de Devoluciones</h2>
        <p>Aceptamos devoluciones dentro de los <strong>30 días naturales</strong> siguientes a la recepción del producto, siempre que:</p>
        <ul>
          <li>El producto esté en su estado original, sin uso y con embalaje íntegro</li>
          <li>Se presente el comprobante de compra</li>
          <li>El producto no sea de categorías exentas (perecederos, artículos personalizados, productos de higiene)</li>
        </ul>
        <h2>Proceso de Devolución</h2>
        <ul>
          <li>Solicita la devolución a través de tu cuenta o a <a href="mailto:contacto@sttora.com">contacto@sttora.com</a></li>
          <li>Recibirás instrucciones en máximo 2 días hábiles</li>
          <li>El reembolso se procesará en 5–10 días hábiles tras recibir y verificar el producto</li>
        </ul>
        <h2>Productos Dañados o Incorrectos</h2>
        <p>Si recibes un producto dañado o diferente al pedido, contáctanos dentro de las 48 horas siguientes con fotografías del producto y empaque.</p>
        <h2>Contacto</h2>
        <p>Para gestionar un envío o devolución: <a href="mailto:contacto@sttora.com">contacto@sttora.com</a></p>
      </div>
    </InnerLayout>
  );
}
